export const useHighlight = (text: string, query: string): { text: string; bold: boolean }[] => {
  if (!query) return [{ text, bold: false }];

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();

  const parts = lowerText.split(lowerQuery);

  const result: { text: string; bold: boolean }[] = [];

  let currentIndex = 0;

  for (const [index, part] of parts.entries()) {
    if (part) {
      result.push({
        text: text.slice(currentIndex, currentIndex + part.length),
        bold: false,
      });
      currentIndex += part.length;
    }

    if (index < parts.length - 1) {
      result.push({
        text: text.slice(currentIndex, currentIndex + query.length),
        bold: true,
      });
      currentIndex += query.length;
    }
  }

  return result;
};
